// An invitation link lands on `/invitations/<token>`, which needs a session.
// Someone clicking it while signed out is sent to the login app, and the path
// — token and all — is lost on the way back. Holding it across that round
// trip is what stops the second click being necessary.

const INVITATION_PATH_PREFIX = '/invitations/'
const STORAGE_KEY = 'pendingInvitationPath'

export const isInvitationPath = (pathname) =>
  pathname.startsWith(INVITATION_PATH_PREFIX)

export const stashInvitationPath = () => {
  if (isInvitationPath(window.location.pathname)) {
    localStorage.setItem(STORAGE_KEY, window.location.pathname)
  }
}

// Restores the path exactly once; a stash left behind by an abandoned login
// must not keep redirecting later sessions.
//
// `canRenderInvitations` is false for every app but the partner one, which
// is the only Switch carrying the route. Those sessions still clear the
// stash — navigating them to a route their app cannot render would replace
// core's "this invitation is no longer valid" with a blank page.
export const restoreInvitationPath = ({ canRenderInvitations } = {}) => {
  const pending = localStorage.getItem(STORAGE_KEY)

  if (!pending) {
    return
  }

  localStorage.removeItem(STORAGE_KEY)

  if (!canRenderInvitations) {
    return
  }

  // Stored by this module from `window.location.pathname`, but read back from
  // storage any script on the origin can write: only ever navigate to an
  // invitation path, never to whatever it happens to hold.
  if (isInvitationPath(pending) && window.location.pathname !== pending) {
    window.history.replaceState({}, '', pending)
  }
}
